<template>
    <div class="container">
        <h1>{{msg}}</h1>
        <canvas ref="charts" id="foo"></canvas>
    </div>
</template>

<script>
    export default {
        name: "Statistics",
        data() {
            return {
                msg: 'Statistics'
            }
        },
        mounted() {
            console.log(  this.$refs.charts, 'Getting the canvas element' );
            let opts = {
                angle: 0, // The span of the gauge arc
                lineWidth: 0.44, // The line thickness
                radiusScale: 1, // Relative radius
                pointer: {
                    length: 0.65, // // Relative to gauge radius
                    strokeWidth: 0.01, // The thickness
                    color: '#000000' // Fill color
                },
                limitMax: false,     // If false, max value increases automatically if value > maxValue
                limitMin: false,     // If true, the min value of the gauge will be fixed
                colorStart: '#6FADCF',   // Colors
                colorStop: '#8FC0DA',    // just experiment with them
                strokeColor: '#E0E0E0',  // to see which ones work best for you
                generateGradient: true,
                highDpiSupport: true,     // High resolution support

            };
            let target = document.getElementById('foo'); // your canvas element
            let gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
            gauge.maxValue = 3000; // set max gauge value
            gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
            gauge.animationSpeed = 32; // set animation speed (32 is default value)
            gauge.set(1250); // set actual value
        }
    }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Statistics.vue